/**
 * 파워북
 */
import { Fragment } from "react";
import { IPowerbook } from "@type/index";


export const PowerbookArticle = ({ item }: {item: IPowerbook}) => {
    if(!item) {
        return <Fragment />;
    }

    const { url, thumbnail, title, content } = item;
    return <div className="search-item-content">
        { thumbnail ? <div className="search-item-thumbnail">
            <a href={ url }>
                <img src={ thumbnail } alt="" />
            </a>
        </div> : <Fragment />}
        <div className="search-item-article">
            <a href={ url }>
                <div className="search-item-title" dangerouslySetInnerHTML={{__html: title}}></div>
                <div className="search-item-summary" dangerouslySetInnerHTML={{__html: content}}></div>
            </a>
        </div>
    </div>
};